module.exports = __webpack_public_path__ + "img/like.9271be1e.svg";